export default "__VITE_ASSET__DXxsGi9R__"